import React from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const StyledAppSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 22.5,
  flexShrink: 0,
  height: 13.5,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2.5,
    transitionDuration: '250ms',
    '&.Mui-checked': {
      transform: 'translateX(9px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      border: '2px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.4,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 8.5,
    height: 8.5,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 13.5 / 2,
    backgroundColor: 'var(--color-gray-base)',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 250,
    }),
  },
}));

const AppSwitch: React.FC<SwitchProps> = (props) => {
  return <StyledAppSwitch {...props} />;
};

export default AppSwitch;
